import React, { Component } from "react";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";

export default class SelectedKit extends Component {

    renderIncludes() {
        const { tempCart } = this.props;
        const kitObj = tempCart.Kit;
        const selectedKit = _.map(kitObj, obj => obj)[0];

        // TODO this needs to be dynamic from admin
        if (selectedKit.id === 3) {
            // panasonic
            return (
                <div>
                    <span className="includes-title"><Translate value="buildAKit.kitProduct.title" name="Panasonic N1" /></span>
                    <ul>
                        <li><Translate value="buildAKit.kitProduct.panasonicN1.li1" /></li>
                        <li><Translate value="buildAKit.kitProduct.panasonicN1.li2" /></li>
                        {/* <li><Translate value="buildAKit.kitProduct.panasonicN1.li3" /></li> */}
                        {/* <li><Translate value="buildAKit.kitProduct.panasonicN1.li4" /></li> */}
                    </ul>
                    <div className="includes-message"><Translate value="buildAKit.kitProduct.panasonicN1.li3" /></div>
                </div>
            )
        } else if (selectedKit.id === 1) {
            // zebra
            return (
                <div>
                    <span className="includes-title"><Translate value="buildAKit.kitProduct.title" name="Zebra TC77" /></span>
                    <ul>
                        <li><Translate value="buildAKit.kitProduct.zebraTc77.li1" /></li>
                        <li><Translate value="buildAKit.kitProduct.zebraTc77.li2" /></li>
                        {/* <li><Translate value="buildAKit.kitProduct.zebraTc77.li3" /></li> */}
                        {/* <li><Translate value="buildAKit.kitProduct.zebraTc77.li4" /></li> */}
                    </ul>
                    <div className="includes-message"><Translate value="buildAKit.kitProduct.panasonicN1.li3" /></div>
                </div>
            )
        }
    }

    render() {
        const { tempCart } = this.props;
        const selectedKit = _.map(tempCart.Kit, obj => obj)[0];

        return (
            <div className="masonry__item kit-product selected-kit-product">
                <div className="row">
                    <div className="col-4">
                        <img alt="Image" src={selectedKit.defaultPictureModel.fullSizeImageUrl} />
                    </div>
                    <div className="col-8 desc-column">
                        <h4>{selectedKit.name}</h4>
                        <h4>{selectedKit.productPrice.price}</h4>
                        <span className="kit-part-number">#{selectedKit.manufacturerPartNumber}</span>
                        <div className="kit-included-list">
                            {this.renderIncludes()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}